/**
 * Botón primario de una pantalla de acceso cuando todavía falta algo.
 *
 * Gris, pero NO `disabled`. La diferencia importa: un botón deshabilitado no
 * responde al click, así que la persona que no encuentra el campo que le falta
 * se queda golpeando un botón muerto sin recibir una sola pista. Acá el click
 * sí entra, marca en rojo lo que falta y sube el aviso — que es justamente la
 * pregunta que la persona estaba haciendo al apretarlo.
 *
 * Por eso tampoco lleva `cursor-not-allowed`: el cursor diría que no pasa nada
 * y sí pasa.
 *
 * `disabled` queda reservado para el envío en curso, donde el click repetido
 * sería un segundo POST.
 */
export const BOTON_ACCESO_INACTIVO = 'bg-muted text-soft shadow-none hover:bg-muted'

/** Clase del botón primario según si el formulario ya está completo. */
export function claseBotonAcceso(listo: boolean): string | undefined {
  return listo ? undefined : BOTON_ACCESO_INACTIVO
}
